import React from "react";

const Logo = ({ dark = false }) => {
  const color = dark ? "#F4F1EA" : "#0A0A0A";
  return (
    <div className="flex items-center gap-3 select-none" style={{ color }}>
      <svg width="52" height="30" viewBox="0 0 52 30" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M9 15C9 9 15 9 19 15C23 21 29 21 33 15C37 9 43 9 43 15C43 21 37 21 33 15C29 9 23 9 19 15C15 21 9 21 9 15Z"
          stroke={color}
          strokeWidth="3.6"
          strokeLinecap="round"
          strokeLinejoin="round"
          fill="none"
        />
      </svg>
      <div className="leading-[0.95]">
        <span className="block text-[17px] font-extrabold tracking-tight uppercase" style={{ fontFamily: "Syne, sans-serif" }}>
          Infinity
        </span>
        <span className="block text-[10px] font-bold tracking-[0.34em] uppercase mono" style={{ opacity: 0.7 }}>
          Solutions
        </span>
      </div>
    </div>
  );
};

export default Logo;
